import { useState } from 'react';

const contacts = [
  {
    id: 'whatsapp',
    icon: 'ri-whatsapp-line',
    label: 'WhatsApp',
    href: 'https://wa.me/995599872020',
    color: '#25D366',
    bg: 'bg-[#25D366]',
  },
  {
    id: 'phone',
    icon: 'ri-phone-line',
    label: '+995 599 87 20 20',
    href: 'tel:+995599872020',
    color: '#1C1C1C',
    bg: 'bg-[#1C1C1C]',
  },
  {
    id: 'email',
    icon: 'ri-mail-line',
    label: 'info@phoenix.ge',
    href: 'mailto:info@phoenix.ge',
    color: '#ec3145',
    bg: 'bg-[#ec3145]',
  },
];

export default function ContactWidget() {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 left-6 z-50 flex flex-col-reverse items-start gap-3">
      {/* Contact options */}
      <div className="flex flex-col-reverse gap-2.5">
        {contacts.map((c, i) => (
          <a
            key={c.id}
            href={c.href}
            target={c.id === 'whatsapp' ? '_blank' : undefined}
            rel={c.id === 'whatsapp' ? 'noopener noreferrer' : undefined}
            className={`flex items-center gap-3 pr-4 pl-1 py-1 rounded-full text-white text-xs font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${c.bg} ${
              open
                ? 'opacity-100 translate-y-0 pointer-events-auto'
                : 'opacity-0 translate-y-4 pointer-events-none'
            }`}
            style={{
              transitionDelay: open ? `${i * 60}ms` : `${(contacts.length - 1 - i) * 40}ms`,
            }}
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
              <i className={`${c.icon} text-base`}></i>
            </span>
            {c.label}
          </a>
        ))}
      </div>

      {/* Toggle button */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-13 h-13 rounded-full flex items-center justify-center text-white transition-all duration-300 cursor-pointer shadow-lg ${
          open ? 'bg-[#1C1C1C] rotate-45' : 'bg-[#ec3145] hover:bg-[#c9283a]'
        }`}
        style={{ width: '52px', height: '52px' }}
        aria-label="კონტაქტი"
      >
        <i className={`text-xl transition-all duration-300 ${open ? 'ri-close-line' : 'ri-customer-service-2-line'}`}></i>
      </button>
    </div>
  );
}
